module.exports = __webpack_public_path__ + "img/play.17b1c416.svg";